import { Block } from 'baseui/block';
import { ValueDisplay } from '../../../components/ValueDisplay'
import { OverviewPanelWrapper } from '../../../components/OverviewPanelWrapper'

import { IHeatingOutlet_Optimizer } from './types'
import { TimeSeriesLineChart } from '../../../../features/Charts/LineCharts/TimeSeriesLineChart';
import { themedUseStyletron } from '../../../../theme/customTheme';

export function OverviewPanel(props: IHeatingOutlet_Optimizer) {
    const [css, theme] = themedUseStyletron();
    return (
        <OverviewPanelWrapper height={theme.appSizes.xSmallAppHeight} {...props}>
            <>
                <ValueDisplay value={props.actSetpoint} dimension={'°C'}></ValueDisplay>
                <TimeSeriesLineChart lines={[{
                label: `OutsideTemperature`,
                lineColor: theme.appColors.aggregate.error,
                objectId: props.id,
                resourceGroupId: props.resourceGroupId,
                propertyName: 'outsideTemperature',
                currentValue: props.outsideTemperature,
                showPoints: false,
                fill: false,
                grace: 0,
            },
            {
                label: `RoomTemperature`,
                lineColor: theme.appColors.aggregate.actualValue,
                objectId: props.id,
                resourceGroupId: props.resourceGroupId,
                propertyName: 'roomTemperature',
                currentValue: props.roomTemperature,
                showPoints: true,
                fill: false,
                yScaleId: 'y',
                grace: 0,
            },
            {
                label: `Actual Setpoint`,
                lineColor: theme.appColors.aggregate.output,
                objectId: props.id,
                resourceGroupId: props.resourceGroupId,
                propertyName: 'actSetpoint',
                currentValue: props.actSetpoint,
                showPoints: false,
                fill: false,
                yScaleId: 'y1',
                grace: 0,
            }]}
            summarizeBy={'1s'}
            timespan={24 * 60}></TimeSeriesLineChart>
            </>
        </OverviewPanelWrapper>
    );
}